import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { OChannel } from '../../models/loyalty-cluster.model';
import { URLSearchParams } from '@angular/http';
import { ListMetadata } from '../../models/list-metadata.model';


@Injectable()
export class PromotionClusterHeadOchannelService {

  public baseUrl = '/koncentro-loyalty';

  constructor(
    private http: HttpClientService
  ) { }

  get(clusterHeadId, oChannelId): Observable<OChannel> {
    return this.http.get(this.baseUrl + '/cluster_head/' + clusterHeadId + '/ochannel/' + oChannelId);
  }

  list(clusterHeadId, offset = null, limit = null, search?: Array<{ key: string, value: string }>): Observable <{data: Array<OChannel>, metadata: ListMetadata}> {
    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }

    if ( offset !== null ) {
      params.set('offset', offset.toString());
    }
    if ( limit !== null ) {
      params.set('limit', limit.toString());
    }

    return this.http.get(this.baseUrl + '/cluster_head/' + clusterHeadId + '/ochannel?' + params.toString());
  }

  update(oChannel: OChannel): Observable<OChannel> {
    return this.http.put(this.baseUrl + '/cluster_head/' + oChannel.id + '/ochannel/' + oChannel.ochannel_id, oChannel);
  }

  create(oChannel: OChannel): Observable<OChannel> {
    return this.http.post(this.baseUrl + '/cluster_head/' + oChannel.id + '/ochannel/', oChannel );
  }

  remove(clusterHeadId, oChannelId): Observable<OChannel> {
    return this.http.delete(this.baseUrl + '/cluster_head/' + clusterHeadId  + '/ochannel/' + oChannelId);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-clusterhead-ochannel.service.ts